/* eslint-disable */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-return-assign */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/no-autofocus */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-console */
/* eslint-disable react/button-has-type */
/* eslint-disable no-empty-pattern */
/* eslint-disable no-multi-assign */
/* eslint-disable camelcase */
import React, {
  useContext, useEffect, useMemo, useRef
} from 'react'
import { useLocation, useParams } from 'react-router'
import { setPageAnalytics } from '@apps/utils/Analytics'
import ConsumerActivationPaths from '@sites/consumer/activation/ConsumerActivationPaths'
import { APPLICATION_STATE, ApplicationContext } from '@apps/contexts/ApplicationContext'
import { useHistory } from 'react-router-dom'
import { getBySlug, getShortTextFromPage, getById, getByTitle } from '@apps/utils/contentful'
import DealerSessionCard from '@apps/components/DealerSessionCard'
import { PAYMENT_STATE, updatePaymentStates } from '@apps/redux/features/PayAndReviewSlice'
import Sites from '@sites/index'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { PLANS_STATE, updatePlansState } from '@apps/redux/features/PlansSlice'
import Heading1 from '@/apps/components/Typography/Heading1'
import BodySmall from '@/apps/components/Typography/BodySmall'
import BodySmallBold from '@/apps/components/Typography/BodySmallBold'
import { ANALYTICS_EVENT_TYPES } from '@apps/utils/constants'
import useTagManagerInfo from '../../../_engine/hooks/useTagManagerInfo'
import MarkdownRenderer from '@/apps/components/MarkdownRenderer'
import { Button, CardInfo, Image, Link, Typography } from '@telus/koodo-ui-kit'
import { setVerifyMode, VERIFY_MODE } from '@apps/redux/features/AuthSlice'
import ProxyOperations from '@apps/flows/activation/services/operations'
import Brands from '@brands/index'
import { normalizePlanByIdForLocale, convertPlanPromoBundlesToDollars } from '@apps/utils/planByIdNormalizer'
import { buildAutoPromoState } from '@apps/utils/autoPromo'

const { getPlanById } = ProxyOperations(Brands.public)

const INTRO_CARD_STRONG_CLASS =
  '[&_strong]:!font-bold [&_strong]:font-h2 [&_strong]:text-[16px] [&_strong]:leading-[24px] [&_strong]:tracking-[0px]'

const INTRO_CARD_HEADING_STRONG_CLASS =
  `${INTRO_CARD_STRONG_CLASS} [&_strong:first-of-type]:text-[20px] [&_strong:first-of-type]:leading-[28px]`

const getCardParagraphClass = (i, variant) => {
  const base = 'text-copy font-body'
  const body = `${base} text-[16px] leading-[24px] tracking-[0px]`
  if (i === 0) {
    return `${body} ${INTRO_CARD_HEADING_STRONG_CLASS} pb-6 sm:pb-0 mb-0 sm:mb-4`
  }
  if (variant === 'withFourth' && i === 3) return `${body} ${INTRO_CARD_STRONG_CLASS} pb-4 mb-0`
  // Figma spec for body paragraph: Stag Sans 400 (StagSans-Book) / 16px / line-height 24px / letter-spacing 0
  if (variant === 'noBottomPadLast') return `${body} ${INTRO_CARD_STRONG_CLASS} pb-6 last:pb-0 mb-0`
  return `${body} ${INTRO_CARD_STRONG_CLASS} pb-6 mb-0`
}

const normalizeIntroCardMarkdown = (value) => {
  if (!value) return value
  return value.replace(/^__([\s\S]+?)__(\s*)/, (_, heading, spacing) => `**${heading}**${spacing || ' '}`)
}

const normalizeTransferNumberMarkdown = (value) => {
  if (!value) return value
  return value.replace(/(^|\r?\n)[\t ]*\\[\t ]*(?=\r?\n|$)/g, '$1')
}

const TransferNumberParagraph = ({ children, index }) => {
  const base = 'text-copy font-body text-[16px] leading-[24px] tracking-[0px]'
  const strongClass = index === 0
    ? INTRO_CARD_HEADING_STRONG_CLASS
    : INTRO_CARD_STRONG_CLASS
  const spacingClass = index === 0 ? 'm-0' : 'm-0 !mt-6'

  return <p className={`${base} ${strongClass} ${spacingClass}`}>{children}</p>
}

TransferNumberParagraph.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number
}

const TransferNumberList = ({ children }) => (
  <ul className="text-copy mb-0 list-outside2 list-disc ml-4 !mt-6">{children}</ul>
)

TransferNumberList.propTypes = {
  children: PropTypes.node
}

const TRANSFER_NUMBER_MARKDOWN_COMPONENTS = {
  p: TransferNumberParagraph,
  ul: TransferNumberList
}

const normalizeImageName = (value) => String(value || '').trim().toLowerCase()

const getImageFileName = (image) => {
  return normalizeImageName(image?.url).split('?')[0].split('/').pop()
}

const imageMatchesNames = (image, names) => {
  const imageNames = [
    image?.title,
    image?.fileName,
    image?.filename,
    image?.name,
    getImageFileName(image)
  ].map(normalizeImageName)

  return names.map(normalizeImageName).some((name) => imageNames.includes(name))
}

const getImageByNames = (images, preferredNames, fallbackNames = []) => {
  return (
    images.find((image) => imageMatchesNames(image, preferredNames)) ||
    images.find((image) => imageMatchesNames(image, fallbackNames)) ||
    {}
  )
}

const INTRO_BODY_COPY_COLOR = 'var(--color-copy)'

// Figma spec for phone compatibility regular text: Stag Sans 400 / 16px / line-height 24px / letter-spacing 0
const introBodySmallTypographyProps = {
  block: false,
  variant: { size: 'small' },
  tokens: {
    color: INTRO_BODY_COPY_COLOR,
    fontSize: 16,
    fontWeight: '400',
    lineHeight: 1.5
  }
}

const introBodySmallBoldTypographyProps = {
  block: true,
  align: 'center',
  variant: { size: 'small', weight: 'bold' },
  tokens: {
    color: INTRO_BODY_COPY_COLOR,
    fontSize: 16,
    fontWeight: '700',
    letterSpacing: 0,
    lineHeight: 1.5
  }
}

const introPrivacyTypographyProps = {
  block: true,
  align: 'center',
  variant: { size: 'small' },
  tokens: {
    color: INTRO_BODY_COPY_COLOR,
    fontSize: 14,
    fontWeight: '400',
    lineHeight: 1.43
  }
}

const introButtonTypographyProps = {
  variant: { size: 'medium', weight: 'bold' },
  tokens: {
    color: '#ffffff',
    fontSize: 18,
    fontWeight: '600',
    lineHeight: 1.33
  }
}

const CardSection = ({
  id,
  asset,
  markdown,
  trackPrefix,
  variant = 'default',
  pushClickAnalytics
}) => {
  const paragraphVariant =
    variant === 'payment' ? 'noBottomPadLast' : variant === 'simCard' ? 'withFourth' : 'default'
  const normalizedMarkdown = normalizeIntroCardMarkdown(markdown)
  const useTransferNumberMarkdownLayout =
    id === 'switchNumbers' && /^[\t ]*-\s+/m.test(normalizedMarkdown || '')
  const renderedMarkdown = useTransferNumberMarkdownLayout
    ? normalizeTransferNumberMarkdown(normalizedMarkdown)
    : normalizedMarkdown
  const bodyClassName = [
    'flex-1 p-6 lg:space-y-4',
    id === 'payment' ? 'kpre-intro-payment-card-body' : ''
  ].filter(Boolean).join(' ')
  const mediaContent = (
    <div className="flex items-center justify-center bg-[#A1ED00] h-[360px] md:h-60">
      <div className="max-w-[78%] h-[260px] md:max-h-[180px] [&_img]:!w-full [&_img]:!h-full [&_img]:object-contain">
        <Image
          src={asset?.url}
          alt={asset?.title || ''}
        />
      </div>
    </div>
  )

  return (
    <div className="kpre-intro-card-shell flex flex-col flex-1 min-w-0">
      {/*
        Existing Card implementation kept as reference for the full-bleed layout.
        <Card
          className="kpre-intro-card"
          testId={`intro-card-${id || trackPrefix}`}
          variant={{ padding: 'custom', borderRadius: 'small' }}
          tokens={{
            paddingBottom: 0,
            paddingLeft: 0,
            paddingRight: 0,
            paddingTop: 0
          }}
          fullBleedContent={{
            content: mediaContent,
            position: 'top',
            align: 'stretch'
          }}
        >
          <div className="flex-1 p-6 lg:space-y-4">
              <MarkdownRenderer
              markdown={markdown}
              onLinkClick={(text, url) =>
                pushClickAnalytics(text, `${trackPrefix}_${text}_link_click`, url)
              }
              paragraphClassForIndex={(i) => getCardParagraphClass(i, paragraphVariant)}
            />
          </div>
        </Card>
      */}
      <CardInfo
        className="kpre-intro-card"
        testId={`intro-card-${id || trackPrefix}`}
        variant={{ style: 'lightest', padding: 'custom', borderRadius: 'small' }}
        tokens={{
          backgroundColor: '#ffffff',
          borderWidth: 0
        }}
      >
        {mediaContent}
        <div className={bodyClassName}>
          <MarkdownRenderer
            markdown={renderedMarkdown}
            onLinkClick={(text, url) =>
              pushClickAnalytics(text, `${trackPrefix}_${text}_link_click`, url)
            }
            paragraphClassForIndex={(i) => getCardParagraphClass(i, paragraphVariant)}
            linkPrimaryClass={false}
            linkFontClass="font-h4"
            componentOverrides={
              useTransferNumberMarkdownLayout ? TRANSFER_NUMBER_MARKDOWN_COMPONENTS : undefined
            }
          />
        </div>
      </CardInfo>
    </div>
  )
}

const IntroPage = ({ path = '' }) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const {
    content: { pageContent, featureFlags: pageFeatureFlags },
    userType
  } = useSelector((state) => state.common)
  const { [PLANS_STATE.PLAN]: selectedPlan } = useSelector((state) => state.plansPage)

  const {
    [APPLICATION_STATE.CURRENT_LANGUAGE]: language,
    [APPLICATION_STATE.CURRENT_REGION]: region,
    [APPLICATION_STATE.IDENTITY]: identity
  } = useContext(ApplicationContext)

  const landingPageContent = useMemo(() => {
    if (!pageContent || !language) return {}
    const landingPage = getById(pageContent, 'landingPage')
    return landingPage[language]
  }, [pageContent, language])

  const isDealer = userType === Sites.dealer
  const pagePrefix = isDealer ? 'Dealer' : 'Consumer'
  const plansPageContent = getById(pageContent, `plansPage${pagePrefix}`) || {}
  const autoPromoText = getBySlug(plansPageContent[language]?.shortTextFields, 'autoPromoText')?.value

  const consumerActivationPaths = new ConsumerActivationPaths()

  const { planName } = useParams()

  const paymentState = useSelector((state) => state.payAndReviewPage)

  const updatePaymentStore = (payload) => {
    dispatch(updatePaymentStates(payload))
  }

  const {
    [PAYMENT_STATE.PROMO.MULTI_PROMOTION_CODE_INFO]: multiPromotionCodeInfo,
    [PAYMENT_STATE.PROMO.MULTI_PROMO_CODES]: multiPromoCodes
  } = paymentState

  const featureFlags = pageFeatureFlags?.[0] || {}
  if (featureFlags?.showSplashing) {
    history.push(consumerActivationPaths.Splash)
    return null
  }

  const { shortTextFields, longTextFields, images } = landingPageContent

  const location = useLocation()
  const hasConsumerFetchRun = useRef(false)
  const hasDealerFetchRun = useRef(false)
  const preselectedPlanFetchRunRef = useRef('')

  const planPreSelected = () => {
    return !!planName
  }

  const tagManagerInfo = useTagManagerInfo({
    customFields: {
      plan_name: planPreSelected() ? planName : 'NA',
      plan_cost: planPreSelected() ? selectedPlan?.value : 'NA',
      journey_type: 'NA'
    }
  })

  const pushTagManagerToDataLayer = () => {
    try {
      if (typeof window !== 'undefined') {
        window.dataLayer = window.dataLayer || []
        const analyticsData = setPageAnalytics(location, 'form', region, language, tagManagerInfo)
        if (analyticsData) {
          if (typeof window.gtag === 'undefined') {
            window.gtag = function () {
              console.warn('gtag not available, analytics data queued')
            }
          }
          window.dataLayer.push(analyticsData)
        }
      }
    } catch (error) {
      console.warn('Analytics error:', error)
    }
  }

  const pushClickAnalytics = (click_text, event_type, target_link, event_click = ANALYTICS_EVENT_TYPES.CLICK) => {
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || []
      const analyticsData = setPageAnalytics(location, 'click', region, language, {
        ...tagManagerInfo,
        click_text
      }, event_type, event_click, target_link)
      if (analyticsData) {
        if (typeof window.gtag === 'undefined') {
          window.gtag = function () { }
        }
        window.dataLayer.push(analyticsData)
      }
    }
  }

  const handleGetStarted = () => {
    pushClickAnalytics(textContent?.activationGetStarted, 'Get started click')
    dispatch(setVerifyMode(VERIFY_MODE.NEW))
    history.push(consumerActivationPaths.Verify, { from: location.pathname })
  }

  const handleContinueActivation = () => {
    pushClickAnalytics(
      getShortTextFromPage(landingPageContent, 'or-continue-yourprevious-activation'),
      'continue your previous activation click'
    )
    dispatch(setVerifyMode(VERIFY_MODE.CONTINUE))
    history.push(consumerActivationPaths.Verify, { from: location.pathname })
  }

  useEffect(() => {
    if (userType === Sites.consumer && !hasConsumerFetchRun.current) {
      // The deep-linked flow reports plan_cost, so hold the page view until the
      // preselected plan lookup below has landed.
      if (planPreSelected() && selectedPlan?.sluggedName?.toLowerCase() !== planName?.toLowerCase()) return
      setTimeout(() => {
        pushTagManagerToDataLayer()
      }, 0)
      hasConsumerFetchRun.current = true
      return
    }
    if (userType === Sites.dealer && identity && !hasDealerFetchRun.current) {
      setTimeout(() => {
        pushTagManagerToDataLayer()
      }, 0)
      hasDealerFetchRun.current = true
    }
  }, [location, selectedPlan, identity, userType])

  // Auto-applies the preselected plan's promo. Kept in its own effect so it
  // still runs when the feature flags arrive after the plan lookup resolves.
  useEffect(() => {
    if (userType !== Sites.consumer || !planPreSelected()) return
    if (!featureFlags?.enableMultiPromo || !selectedPlan?.promo) return

    const autoPromoState = buildAutoPromoState({
      promo: selectedPlan.promo,
      multiPromotionCodeInfo,
      multiPromoCodes,
      autoPromoText,
      enableMultiPromo: featureFlags?.enableMultiPromo
    })
    if (autoPromoState) updatePaymentStore(autoPromoState)
  }, [featureFlags, selectedPlan, userType, autoPromoText])

  // Preselected (deep-linked) flow only. getPlanById resolves the slug on its
  // own now, so the plan no longer has to be looked up in the Plan MFE catalog
  // to turn `planName` into a planId first.
  useEffect(() => {
    let isMounted = true

    const lookupPreselectedPlanBySlug = async () => {
      if (userType !== Sites.consumer || !planPreSelected()) return

      const selectedProvinceFromPath = location?.pathname?.split('/').filter(Boolean)?.[1] || ''
      const selectedProvince = `${region || selectedProvinceFromPath}`.toUpperCase()
      if (!selectedProvince) return

      const fetchKey = `${planName}:${selectedProvince}:${language}`
      if (preselectedPlanFetchRunRef.current === fetchKey) return

      preselectedPlanFetchRunRef.current = fetchKey

      try {
        const planByIdResult = await getPlanById({
          sluggedName: planName,
          phoneNumber: '',
          selectedProvince
        })

        if (!isMounted) return

        // The backend turns transport errors and bad payloads into an error
        // envelope rather than throwing, so an unknown slug lands here.
        if (!planByIdResult?.data) {
          preselectedPlanFetchRunRef.current = ''
          window.location = consumerActivationPaths.Base
          return
        }

        const freshPlan = convertPlanPromoBundlesToDollars(
          normalizePlanByIdForLocale(planByIdResult.data, language)
        )

        dispatch(
          updatePlansState({
            [PLANS_STATE.PLAN]: freshPlan,
            [PLANS_STATE.PRE_SELECTED_PLAN]: true
          })
        )
      } catch (error) {
        if (!isMounted) return

        preselectedPlanFetchRunRef.current = ''
        console.error('[IntroPage] preselected getPlanById failed:', error)
      }
    }

    lookupPreselectedPlanBySlug()

    return () => {
      isMounted = false
    }
  }, [language, location.pathname, planName, region, userType])

  const textContent = useMemo(() => {
    if (!shortTextFields && !longTextFields) return {}
    return {
      activationGetStartedMessage: getBySlug(shortTextFields, 'activationGetStartedMessage')?.value,
      activationPrivacyPolicy: getBySlug(shortTextFields, 'activationPrivacyPolicy')?.value,
      activationPrivacyPolicyLink: getBySlug(shortTextFields, 'activationPrivacyPolicyLink')?.value,
      activationGetStarted: getBySlug(shortTextFields, 'activationGetStarted')?.value,
      phoneCompatibility: getBySlug(shortTextFields, 'phoneCompatibility')?.value,
      findOutMore: getBySlug(shortTextFields, 'findOutMore')?.value,
      phoneCompatibilityHelp: getBySlug(shortTextFields, 'phoneCompatibilityHelp')?.value,
      headerTitle: getBySlug(shortTextFields, 'header-title')?.value,
      headerSubtitle: getBySlug(shortTextFields, 'header-subtitle')?.value,
      simCardContent: getBySlug(longTextFields, 'sim-card-content')?.value,
      transferNumberCardContent: getBySlug(longTextFields, 'transfer-number-card-content')?.value,
      pickPlanCardContent: getBySlug(longTextFields, 'pick-plan-card-content')?.value,
      paymentCardContent: getBySlug(longTextFields, 'payment-card-content')?.value,
    }
  }, [shortTextFields, longTextFields])

  const assets = useMemo(() => {
    if (!images) return {}
    return {
      simCard: getImageByNames(images, ['sim-card.png', 'sim-card'], ['sim card']),
      switchNumbers: getImageByNames(
        images,
        ['transfer-phones.png', 'transfer-phones'],
        ['switch numbers']
      ),
      pickPlan: getImageByNames(images, ['gumball-modern-hd.png', 'gumball-modern-hd'], ['pick plan']),
      payment: getImageByNames(images, ['piggy-bank.png', 'piggy-bank'], ['payment']),
    }
  }, [images])

  // Legacy handler stubs removed — auth logic lives in VerifyPage now

  const cardConfigs = [
    { id: 'simCard', markdown: textContent?.simCardContent, trackPrefix: 'Column_1', variant: 'simCard' },
    { id: 'switchNumbers', markdown: textContent?.transferNumberCardContent, trackPrefix: 'Column_2' },
    { id: 'pickPlan', markdown: textContent?.pickPlanCardContent, trackPrefix: 'Column_3' },
    { id: 'payment', markdown: textContent?.paymentCardContent, trackPrefix: 'Column_4', variant: 'payment' }
  ]

  return (
    <div className="bg-[#fafafa] -mx-[calc(50vw-50%)] px-[calc(50vw-50%)] py-8">
      <div className="flex flex-col max-w-6xl px-4 pb-12 m-auto space-y-8 lg:space-y-12">
        <DealerSessionCard />
        <div className="text-center lg:space-y-0">
          <Heading1
            className="pt-8 kpre-intro-header-title"
            align="center"
            variant={{ size: 'h1', colour: 'black', weight: 'bold' }}
            tokens={{
              fontSize: 48,
              lineHeight: 1,
              letterSpacing: 0
            }}
          >
            {textContent?.headerTitle}
          </Heading1>
          <BodySmallBold {...introBodySmallBoldTypographyProps} className="mt-2">
            {textContent?.headerSubtitle}
          </BodySmallBold>
        </div>
        <div className="kpre-intro-card-row flex flex-col space-y-4 md:space-y-0 lg:space-y-0 md:flex-row lg:flex-row md:space-x-4 lg:space-x-4">
          {cardConfigs
            .filter(cfg => !(planPreSelected() && cfg.id === 'pickPlan'))
            .map(cfg => (
              <CardSection
                key={cfg.id}
                id={cfg.id}
                asset={assets?.[cfg.id]}
                markdown={cfg.markdown}
                trackPrefix={cfg.trackPrefix}
                variant={cfg.variant}
                pushClickAnalytics={pushClickAnalytics}
              />
            ))}
        </div>
        <div className="flex flex-col items-center self-center justify-center w-full">
          <div className="w-full">
            <BodySmall {...introPrivacyTypographyProps}>
              {textContent?.activationGetStartedMessage}
              <br />
              <Link
                href={textContent?.activationPrivacyPolicyLink}
                hrefAttrs={{ target: '_blank', rel: 'noopener noreferrer' }}
                className="font-stag-sans"
                variant={{ size: 'small' }}
                tokens={{ blockFontWeight: '700' }}
                onClick={() => pushClickAnalytics(textContent?.activationPrivacyPolicy, 'privacy policy click')}
              >
                {textContent?.activationPrivacyPolicy}
              </Link>
            </BodySmall>
          </div>
          <div className="w-full sm:w-4/12 mt-8">

            {textContent?.activationGetStarted && (
              <Button
                testId="get-started"
                onPress={handleGetStarted}
                variant={{ width: 'full' }}
              >
                <Typography {...introButtonTypographyProps}>
                  {textContent?.activationGetStarted}
                </Typography>
              </Button>
            )}
          </div>

          <div className="w-full sm:w-4/12 mt-2 mb-6 cursor-pointer text-center">
            <Link
              tabIndex="0"
              href="#"
              testId="intropage-continue-activation"
              tokens={{
                blockFontSize: 16,
                blockFontWeight: '700',
                blockLineHeight: 1.5,
                color: 'var(--color-copy)'
              }}
              onClick={(event) => {
                event.preventDefault()
                handleContinueActivation()
              }}
            >
              {getShortTextFromPage(landingPageContent, 'or-continue-yourprevious-activation')}
            </Link>
          </div>
          <div className="w-full text-center sm:w-4/12 lg:w-auto lg:whitespace-nowrap">
            <BodySmall {...introBodySmallTypographyProps}>
              {textContent?.phoneCompatibility}
              {' '}
              {/* <LegacyLink href={textContent?.phoneCompatibilityHelp} className="font-h1" onClick={() => pushClickAnalytics(textContent?.findOutMore, 'find out more click')}>
              {textContent?.findOutMore}
            </LegacyLink> */}
              <Link
                href={textContent?.phoneCompatibilityHelp}
                className="font-stag-sans kpre-intro-compatibility-link"
                tokens={{
                  blockFontSize: 16,
                  blockFontWeight: '600',
                  blockLineHeight: 1.5,
                  color: 'var(--color-copy)'
                }}
                onClick={() => pushClickAnalytics(textContent?.findOutMore, 'find out more click')}
              >
                {textContent?.findOutMore}
              </Link>
            </BodySmall>
          </div>
          <div data-component="payment-summary-cookie-anchor" className="w-full mt-4 flex justify-center" />
        </div>
      </div>
    </div>
  )
}

IntroPage.propTypes = {
  path: PropTypes.string.isRequired
}

export default IntroPage
